import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import CeramicHighlight from "../components/CeramicHighlight";
import About from "../components/About";
import Process from "../components/Process";
import Gallery from "../components/Gallery";
import CuratedReviews from "../components/CuratedReviews";
import ServiceAreas from "../components/ServiceAreas";
import StudioMap from "../components/StudioMap";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { SEO, localBusinessSchema, faqSchema, breadcrumbSchema } from "../components/SEO";
import { BRAND, FAQS } from "../mock";

export default function Home() {
  return (
    <div className="grain bg-jester-deep text-white">
      <SEO
        title="Ceramic Coating Mississauga | #1 Rated Studio. From $550 | Jester Werks"
        description="Ceramic Coating Mississauga from $550. Jester Werks is the #1 rated, most-reviewed ceramic coating studio in Mississauga. 250+ five-star Google reviews, 1,500+ cars coated, 5-year warranty, free window coating included. Serving Port Credit, Streetsville, Erin Mills, Square One & all of the GTA. Call (647) 646-7223."
        canonical={`${BRAND.url}/`}
        schemas={[
          localBusinessSchema(),
          faqSchema(FAQS),
          breadcrumbSchema([{ name: "Home", url: `${BRAND.url}/` }]),
        ]}
      />
      <Navbar />
      <Hero />
      <Stats />
      <CeramicHighlight />
      <About />
      <Process />
      <Gallery />
      <CuratedReviews />
      <ServiceAreas />
      <StudioMap />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
